import { EMemberChoicesLabels } from 'affiny-core/modules/api/models/memberchoice/memberchoice.types';
import { getSimpleAnswerFromLabel } from 'affiny-core/modules/helpers/informationList';
import { TAnswersLabels } from 'affiny-core/modules/memberchoices/types';

export const selectVision = (memberAnswers: TAnswersLabels) => ({
  look: getSimpleAnswerFromLabel(
    memberAnswers,
    EMemberChoicesLabels.sociotestLook
  ),
  bodyPart: getSimpleAnswerFromLabel(
    memberAnswers,
    EMemberChoicesLabels.sociotestBodyPartAttraction
  ),
});

export type IVision = ReturnType<typeof selectVision>;
